/* NICOHUB Quick Order — matching, CSV import and page wiring.
   All calculations live on the NHQO object so the test harness can run the
   exact same functions outside a browser. DOM wiring sits at the bottom and
   only runs when a [data-nh-qo-root] element exists on the page. */
(function (root) {
  'use strict';

  var NHQO = {};

  /* ===================== text normalising & matching ===================== */

  NHQO.normName = function (s) {
    if (s == null) return '';
    s = String(s).toLowerCase();
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) { /* old JS engines */ }
    s = s.replace(/&/g, ' and ');
    s = s.replace(/[^a-z0-9\u0e00-\u0e7f]+/g, ' '); /* keep Thai characters */
    return s.replace(/\s+/g, ' ').trim();
  };

  /* Score how well a customer-typed name fits a catalog name (both normalised).
     100 exact · 85 one is the start of the other · 70-85 all words present ·
     60 substring · 40-60 most words present · 0 no fit */
  NHQO.scoreMatch = function (queryNorm, candNorm) {
    if (!queryNorm || !candNorm) return 0;
    if (queryNorm === candNorm) return 100;
    if (queryNorm.length >= 3 &&
        (candNorm.indexOf(queryNorm) === 0 || queryNorm.indexOf(candNorm) === 0)) return 85;
    var q = queryNorm.split(' ');
    var c = candNorm.split(' ');
    var inC = {};
    c.forEach(function (t) { inC[t] = true; });
    var hit = 0;
    q.forEach(function (t) { if (inC[t]) hit++; });
    if (hit === q.length) return 70 + 15 * (q.length / c.length);
    if (queryNorm.length >= 3 && candNorm.indexOf(queryNorm) !== -1) return 60;
    var ratio = hit / q.length;
    if (ratio >= 0.6) return 40 + 20 * ratio;
    return 0;
  };

  /* candidates: [{ vid, productId, title, nameNorm, sku, available, ... }] */
  NHQO.matchLine = function (rawName, candidates) {
    var qn = NHQO.normName(rawName);
    if (!qn) return { status: 'empty' };
    var qsku = String(rawName).trim().toLowerCase();
    var best = null, second = null;
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      var s = (c.sku && qsku && c.sku === qsku) ? 100 : NHQO.scoreMatch(qn, c.nameNorm);
      if (!best || s > best.score) { second = best; best = { c: c, score: s }; }
      else if (!second || s > second.score) { second = { c: c, score: s }; }
    }
    if (!best || best.score < 55) return { status: 'unmatched', query: rawName };
    if (second && second.score >= 55 && (best.score - second.score) <= 4 &&
        String(second.c.productId) !== String(best.c.productId)) {
      return { status: 'ambiguous', query: rawName, options: [best.c.title, second.c.title] };
    }
    return { status: 'matched', candidate: best.c, score: best.score };
  };

  /* ============================ CSV parsing ============================ */

  NHQO.detectDelimiter = function (text) {
    var lines = String(text || '').replace(/^\uFEFF/, '').split(/\r\n|\r|\n/);
    var first = '';
    for (var i = 0; i < lines.length; i++) { if (lines[i].trim() !== '') { first = lines[i]; break; } }
    var counts = { ',': 0, ';': 0, '\t': 0 };
    var inQ = false;
    for (var j = 0; j < first.length; j++) {
      var ch = first[j];
      if (ch === '"') inQ = !inQ;
      else if (!inQ && counts.hasOwnProperty(ch)) counts[ch]++;
    }
    var best = ',';
    if (counts[';'] > counts[best]) best = ';';
    if (counts['\t'] > counts[best]) best = '\t';
    return best;
  };

  /* Quote-aware parse → array of rows, each an array of cell strings.
     Handles BOM, CRLF, quoted commas and doubled quotes. */
  NHQO.parseCsv = function (text) {
    text = String(text == null ? '' : text).replace(/^\uFEFF/, '');
    var delim = NHQO.detectDelimiter(text);
    var rows = [], cells = [], cell = '', inQ = false;
    function endCell() { cells.push(cell); cell = ''; }
    function endRow() {
      endCell();
      var allEmpty = true;
      for (var k = 0; k < cells.length; k++) { if (cells[k].trim() !== '') { allEmpty = false; break; } }
      if (!allEmpty) rows.push(cells);
      cells = [];
    }
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (inQ) {
        if (ch === '"') { if (text[i + 1] === '"') { cell += '"'; i++; } else { inQ = false; } }
        else cell += ch;
      } else if (ch === '"' && cell.trim() === '') { inQ = true; cell = ''; }
      else if (ch === delim) endCell();
      else if (ch === '\n') endRow();
      else if (ch === '\r') { if (text[i + 1] === '\n') i++; endRow(); }
      else cell += ch;
    }
    if (cell !== '' || cells.length) endRow();
    return { rows: rows, delimiter: delim };
  };

  NHQO.HEADER_WORDS = /^(product\s*names?|products?|items?|names?|skus?|titles?|qty|quantity|quantities|amounts?|q'?ty|pcs|cans|สินค้า|จำนวน)$/i;

  NHQO.looksLikeHeader = function (cells) {
    for (var i = 0; i < cells.length; i++) {
      if (NHQO.HEADER_WORDS.test(String(cells[i]).trim())) return true;
    }
    return false;
  };

  /* rows → [{name, qty}] ; first column = name, first whole number after it = qty (default 1) */
  NHQO.toOrderLines = function (rows) {
    rows = (rows || []).slice();
    var hadHeader = rows.length > 0 && NHQO.looksLikeHeader(rows[0]);
    if (hadHeader) rows = rows.slice(1);
    var lines = [];
    rows.forEach(function (cells) {
      var name = String(cells[0] == null ? '' : cells[0]).trim();
      if (!name) return;
      var qty = null;
      for (var i = 1; i < cells.length; i++) {
        var v = String(cells[i] == null ? '' : cells[i]).trim().replace(/,/g, '');
        if (/^\d{1,5}$/.test(v)) { qty = parseInt(v, 10); break; }
      }
      lines.push({ name: name, qty: qty == null ? 1 : qty });
    });
    return { lines: lines, hadHeader: hadHeader };
  };

  /* ===================== filter value ordering ===================== */

  /* Nicohub's own strength scale, weakest → strongest */
  NHQO.INTENSITY_ORDER = ['Nicotine Free', 'Gentle', 'Everyday Lift', 'Energized', 'Amped Up', 'Ultimate Rush'];

  NHQO.sortIntensity = function (values) {
    return (values || []).slice().sort(function (a, b) {
      var ia = NHQO.INTENSITY_ORDER.indexOf(a); if (ia < 0) ia = 99;
      var ib = NHQO.INTENSITY_ORDER.indexOf(b); if (ib < 0) ib = 99;
      return (ia - ib) || String(a).localeCompare(String(b));
    });
  };

  /* "12.8 mg" style values, numerically */
  NHQO.sortMg = function (values) {
    return (values || []).slice().sort(function (a, b) {
      return (parseFloat(a) || 0) - (parseFloat(b) || 0) || String(a).localeCompare(String(b));
    });
  };

  /* ===================== quantities, prices, money ===================== */

  /* Snap a wanted quantity onto the store's ordering rule (min / steps / max).
     Rounds to the NEAREST allowed step, halves up — with the 10s rule:
     1–9 → 10 · 11–14 → 10 · 15–19 → 20 · 21–24 → 20 · 25 → 30 … 0 stays 0. */
  NHQO.snapQty = function (v, min, inc, max) {
    v = Math.floor(Number(v) || 0);
    min = Math.max(1, Math.floor(Number(min) || 1));
    inc = Math.max(1, Math.floor(Number(inc) || 1));
    max = Math.floor(Number(max) || 0);
    if (v <= 0) return 0;
    var k = Math.floor((v - min) / inc + 0.5);
    if (k < 0) k = 0;
    var snapped = min + k * inc;
    if (max > 0 && snapped > max) {
      snapped = min + Math.floor((max - min) / inc) * inc;
      if (snapped < min) snapped = 0;
    }
    return snapped;
  };

  /* Unit price in cents for a quantity, honouring volume price breaks. */
  NHQO.pickUnitPrice = function (qty, basePrice, breaks) {
    var price = Number(basePrice) || 0;
    var sorted = (breaks || []).slice().sort(function (a, b) { return a.q - b.q; });
    for (var i = 0; i < sorted.length; i++) {
      if (qty >= sorted[i].q) price = Number(sorted[i].p);
    }
    return price;
  };

  /* Shopify money string from cents using the shop's money format. */
  NHQO.formatMoney = function (cents, format) {
    var f = (format && String(format)) || '฿{{amount}}';
    function fixed(c, dp, thouSep, decSep) {
      var n = (Number(c) || 0) / 100;
      var neg = n < 0;
      var s = Math.abs(n).toFixed(dp);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
      var out = dp > 0 ? parts[0] + decSep + parts[1] : parts[0];
      return (neg ? '-' : '') + out;
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, key) {
      switch (key) {
        case 'amount': return fixed(cents, 2, ',', '.');
        case 'amount_no_decimals': return fixed(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fixed(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fixed(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fixed(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fixed(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fixed(cents, 0, ' ', '.');
        case 'amount_with_period_and_space_separator': return fixed(cents, 2, ' ', '.');
        default: return fixed(cents, 2, ',', '.');
      }
    });
  };

  /* The order form customers download — EVERY product in stock at that
     moment, quantity 0 (they fill in what they want; 0 = not ordered).
     No stock numbers are ever included. */
  NHQO.buildExampleCsv = function (rows) {
    var lines = ['Product name,Quantity'];
    for (var i = 0; i < (rows || []).length; i++) {
      var r = rows[i];
      if (!r.available) continue;
      var name = String(r.title || '');
      if (name.indexOf(',') !== -1 || name.indexOf('"') !== -1) {
        name = '"' + name.replace(/"/g, '""') + '"';
      }
      lines.push(name + ',0');
    }
    return lines.join('\r\n');
  };

  /* ============== BSS wholesale pricing overlay (bridge period) ==============
     Until the native-pricing cutover, the real wholesale prices live in the
     BSS app. nh-bss-prices.js carries those rules; the customer's tag picks
     the rule, and row prices + totals follow it. */

  NHQO.resolveBssRule = function (customerTags, rulesData) {
    if (!rulesData || !rulesData.rules) return null;
    var mine = {};
    (customerTags || []).forEach(function (t) {
      t = String(t).trim().toLowerCase();
      if (t) mine[t] = true;
    });
    for (var i = 0; i < rulesData.rules.length; i++) {
      var r = rulesData.rules[i];
      for (var j = 0; j < (r.tags || []).length; j++) {
        if (mine[String(r.tags[j]).trim().toLowerCase()]) return r;
      }
    }
    return null;
  };

  NHQO.bssPrice = function (rule, nameNorm, basePrice) {
    if (!rule || !rule.items) return basePrice;
    var e = rule.items[nameNorm];
    if (!e) return basePrice; /* not priced by the rule = normal price (BSS behavior) */
    if (e.f != null) return e.f;
    if (e.d != null) return Math.max(0, basePrice - e.d);
    if (e.p != null) return Math.round(basePrice * (1 - e.p / 100));
    return basePrice;
  };

  /* Volume ladder: cents off EVERY can once the order's total can count
     reaches a level (Hard Sell: 240→฿9, 720→฿15, 1440→฿19, 2400→฿23). */
  NHQO.ladderOff = function (totalCans, ladder) {
    if (!ladder || !ladder.length) return 0;
    var off = 0;
    for (var i = 0; i < ladder.length; i++) {
      if (totalCans >= ladder[i].min && ladder[i].off > off) off = ladder[i].off;
    }
    return off;
  };

  /* ====================== import plan (pure logic) ====================== */

  /* Turn a CSV text + catalog into exactly what should happen on the page.
     Duplicate lines for the same product are summed before snapping. */
  NHQO.buildImportPlan = function (csvText, candidates) {
    var parsed = NHQO.parseCsv(csvText);
    var ol = NHQO.toOrderLines(parsed.rows);
    var plan = {
      totalLines: ol.lines.length, hadHeader: ol.hadHeader,
      set: [], adjusted: [], soldout: [], unmatched: [], ambiguous: [], zeroed: []
    };
    var wanted = {};   /* vid -> { c, qty } */
    var order = [];
    ol.lines.forEach(function (line) {
      var m = NHQO.matchLine(line.name, candidates);
      if (m.status === 'empty') return;
      if (m.status === 'unmatched') { plan.unmatched.push(line.name); return; }
      if (m.status === 'ambiguous') { plan.ambiguous.push({ query: line.name, options: m.options }); return; }
      var c = m.candidate;
      if (!c.available) {
        if (plan.soldout.indexOf(c.title) === -1) plan.soldout.push(c.title);
        return;
      }
      if (!wanted[c.vid]) { wanted[c.vid] = { c: c, qty: 0 }; order.push(c.vid); }
      wanted[c.vid].qty += line.qty;
    });
    order.forEach(function (vid) {
      var w = wanted[vid];
      if (w.qty === 0) {
        plan.zeroed.push(w.c.title);
        plan.set.push({ vid: vid, qty: 0, title: w.c.title });
        return;
      }
      var snapped = NHQO.snapQty(w.qty, w.c.qmin, w.c.qinc, w.c.qmax);
      plan.set.push({ vid: vid, qty: snapped, title: w.c.title });
      if (snapped !== w.qty) {
        var capped = snapped < w.qty && NHQO.snapQty(w.qty, w.c.qmin, w.c.qinc, 0) > snapped;
        plan.adjusted.push({ title: w.c.title, requested: w.qty, set: snapped, capped: capped });
      }
    });
    return plan;
  };

  /* ============================ page wiring ============================ */

  function initRoot(rootEl) {
    if (rootEl.__nhqoInit) return;
    rootEl.__nhqoInit = true;

    var fmt = rootEl.getAttribute('data-money-format') || '฿{{amount}}';
    var cartAddUrl = rootEl.getAttribute('data-cart-add-url') || '/cart/add.js';
    var cartUrl = rootEl.getAttribute('data-cart-url') || '/cart';
    var cartJsUrl = rootEl.getAttribute('data-cart-js-url') || '/cart.js';

    var listEl = rootEl.querySelector('[data-nh-qo-list]');
    var searchEl = rootEl.querySelector('[data-nh-qo-search]');
    var brandEl = rootEl.querySelector('[data-nh-qo-brand]');
    var strengthEl = rootEl.querySelector('[data-nh-qo-strength]');
    var flavorEl = rootEl.querySelector('[data-nh-qo-flavor]');
    var mgEl = rootEl.querySelector('[data-nh-qo-mg]');
    var stockBtns = rootEl.querySelectorAll('[data-nh-qo-stock]');
    var countEl = rootEl.querySelector('[data-nh-qo-count]');
    var clearFiltersEl = rootEl.querySelector('[data-nh-qo-clearfilters]');
    var fileEl = rootEl.querySelector('[data-nh-qo-file]');
    var importBtn = rootEl.querySelector('[data-nh-qo-import]');
    var exampleBtn = rootEl.querySelector('[data-nh-qo-example]');
    var summaryEl = rootEl.querySelector('[data-nh-qo-summary]');
    var barCountEl = rootEl.querySelector('[data-nh-qo-bar-count]');
    var barTotalEl = rootEl.querySelector('[data-nh-qo-bar-total]');
    var addBtn = rootEl.querySelector('[data-nh-qo-add]');
    var clearBtn = rootEl.querySelector('[data-nh-qo-clear]');
    var viewBtn = rootEl.querySelector('[data-nh-qo-vieworder]');
    var barMsgEl = rootEl.querySelector('[data-nh-qo-bar-msg]');
    var emptyEl = rootEl.querySelector('[data-nh-qo-empty]');

    var state = { rows: [], orderOnly: false, stockView: 'in' };

    function rowQty(row) { return parseInt(row.input && row.input.value, 10) || 0; }

    function setRowQty(row, qty) {
      if (!row.input || row.input.disabled) return;
      row.input.value = qty > 0 ? qty : '';
    }

    function lineTotal(row) {
      var q = rowQty(row);
      if (q <= 0) return 0;
      var cans = 0;
      state.rows.forEach(function (r) { cans += rowQty(r); });
      var off = state.bssLadder ? NHQO.ladderOff(cans, state.bssLadder) : 0;
      return Math.max(0, NHQO.pickUnitPrice(q, row.price, row.breaks) - off) * q;
    }

    function update() {
      var items = 0, cans = 0, total = 0;
      state.rows.forEach(function (row) { cans += rowQty(row); });
      var off = state.bssLadder ? NHQO.ladderOff(cans, state.bssLadder) : 0;
      state.rows.forEach(function (row) {
        var q = rowQty(row);
        var unit = Math.max(0, NHQO.pickUnitPrice(q, row.price, row.breaks) - off);
        var t = q > 0 ? unit * q : 0;
        /* write to the screen ONLY when the text actually changed — the BSS
           app watches the whole page and re-scans on every change; needless
           writes here made each click drag */
        var txt = q > 0 ? NHQO.formatMoney(t, fmt) : '';
        if (row.lineEl && row.lineTxt !== txt) { row.lineEl.textContent = txt; row.lineTxt = txt; }
        /* the per-can price drops live once a volume level is reached */
        var pTxt = NHQO.formatMoney(Math.max(0, row.price - off), fmt);
        if (row.priceEl && row.priceTxt !== pTxt) { row.priceEl.textContent = pTxt; row.priceTxt = pTxt; }
        if (q > 0) { items++; total += t; }
      });
      var countTxt = items === 0 ? 'Nothing selected yet'
        : items + (items === 1 ? ' product · ' : ' products · ') + cans + (cans === 1 ? ' can' : ' cans')
          + (off > 0 ? ' · ' + NHQO.formatMoney(off, fmt) + '/can volume discount' : '');
      if (barCountEl && state.lastCount !== countTxt) { barCountEl.textContent = countTxt; state.lastCount = countTxt; }
      var totTxt = NHQO.formatMoney(total, fmt);
      if (barTotalEl && state.lastTotal !== totTxt) { barTotalEl.textContent = totTxt; state.lastTotal = totTxt; }
      if (addBtn) addBtn.disabled = items === 0;
      if (clearBtn) clearBtn.hidden = items === 0;
      if (state.orderOnly && items === 0) {
        /* the last selected item was removed — leave the order view by itself */
        state.orderOnly = false;
        applyFilters();
      }
      if (viewBtn) {
        viewBtn.hidden = items === 0 && !state.orderOnly;
        var vTxt = state.orderOnly ? 'Show all products' : 'View order';
        if (state.lastView !== vTxt) { viewBtn.textContent = vTxt; state.lastView = vTxt; }
      }
      return { items: items, cans: cans, total: total };
    }

    function bindRow(el) {
      if (el.__nhqoBound) return;
      el.__nhqoBound = true;
      var input = el.querySelector('[data-nh-qo-input]');
      var minus = el.querySelector('[data-nh-qo-minus]');
      var plus = el.querySelector('[data-nh-qo-plus]');
      function row() { return el.__nhqoRow; }
      if (minus) minus.addEventListener('click', function () {
        var r = row(); if (!r) return;
        var q = rowQty(r);
        var next = q - r.qinc;
        if (q <= r.qmin) next = 0;
        setRowQty(r, NHQO.snapQty(next, r.qmin, r.qinc, r.qmax));
        update();
      });
      if (plus) plus.addEventListener('click', function () {
        var r = row(); if (!r) return;
        var q = rowQty(r);
        setRowQty(r, NHQO.snapQty(q === 0 ? r.qmin : q + r.qinc, r.qmin, r.qinc, r.qmax));
        update();
      });
      if (input) {
        input.addEventListener('input', update);
        input.addEventListener('change', function () {
          var r = row(); if (!r) return;
          setRowQty(r, NHQO.snapQty(rowQty(r), r.qmin, r.qinc, r.qmax));
          update();
        });
      }
    }

    function collectRows() {
      var els = rootEl.querySelectorAll('.nh-qo-row');
      state.rows = [];
      Array.prototype.forEach.call(els, function (el) {
        var d = el.dataset;
        var row = {
          el: el,
          vid: d.vid,
          productId: d.pid || d.vid,
          title: d.name || '',
          nameNorm: NHQO.normName(d.name),
          sku: (d.sku || '').trim().toLowerCase(),
          vendor: d.vendor || '',
          vendorNorm: NHQO.normName(d.vendor),
          intensity: d.intensity || '',
          flavor: d.flavor || '',
          mg: d.mg || '',
          price: parseInt(d.price, 10) || 0,
          available: d.available === 'true',
          qmin: parseInt(d.qmin, 10) || 1,
          qinc: parseInt(d.qinc, 10) || 1,
          qmax: parseInt(d.qmax, 10) || 0,
          breaks: [],
          input: el.querySelector('[data-nh-qo-input]'),
          lineEl: el.querySelector('[data-nh-qo-line]'),
          priceEl: el.querySelector('.nh-qo-row__price')
        };
        try { row.breaks = JSON.parse(d.breaks || '[]'); } catch (e) { row.breaks = []; }
        el.__nhqoRow = row;
        state.rows.push(row);
        bindRow(el);
      });
    }

    function fillSelect(el, values) {
      if (!el) return;
      var current = el.value;
      var found = false;
      while (el.options.length > 1) el.remove(1);
      values.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v; o.textContent = v;
        el.appendChild(o);
        if (v === current) found = true;
      });
      el.value = found ? current : '';
    }

    function uniqueOf(key) {
      var seen = {}, out = [];
      state.rows.forEach(function (r) {
        var v = r[key];
        if (v && !seen[v]) { seen[v] = true; out.push(v); }
      });
      return out;
    }

    function rebuildFilters() {
      fillSelect(brandEl, uniqueOf('vendor').sort(function (a, b) { return a.localeCompare(b); }));
      fillSelect(strengthEl, NHQO.sortIntensity(uniqueOf('intensity')));
      fillSelect(flavorEl, uniqueOf('flavor').sort(function (a, b) { return a.localeCompare(b); }));
      fillSelect(mgEl, NHQO.sortMg(uniqueOf('mg')));
    }

    function applyFilters() {
      var q = NHQO.normName(searchEl ? searchEl.value : '');
      var qRaw = (searchEl ? searchEl.value : '').trim().toLowerCase();
      var brand = brandEl ? brandEl.value : '';
      var strength = strengthEl ? strengthEl.value : '';
      var flavor = flavorEl ? flavorEl.value : '';
      var mg = mgEl ? mgEl.value : '';
      var active = !!(q || brand || strength || flavor || mg || state.stockView !== 'in');
      var visible = 0, elsewhere = 0;
      state.rows.forEach(function (r) {
        var base = (!state.orderOnly || rowQty(r) > 0) &&
                 (!brand || r.vendor === brand) &&
                 (!strength || r.intensity === strength) &&
                 (!flavor || r.flavor === flavor) &&
                 (!mg || r.mg === mg) &&
                 (!q || r.nameNorm.indexOf(q) !== -1 || r.vendorNorm.indexOf(q) !== -1 ||
                  (qRaw && r.sku && r.sku.indexOf(qRaw) !== -1));
        var ok = base && (state.stockView === 'all' || r.available);
        r.el.hidden = !ok;
        if (ok) visible++;
        else if (base) elsewhere++; /* it matches, just lives under the other stock pill */
      });
      if (emptyEl) {
        emptyEl.hidden = visible !== 0;
        if (visible === 0) {
          var narrowed = !!(q || brand || strength || flavor || mg || state.orderOnly);
          emptyEl.textContent = !narrowed
            ? 'No products to show yet.'
            : (elsewhere > 0
                ? 'Matches are currently sold out — switch to “Show all” to see them.'
                : 'No products match your search.');
        }
      }
      if (countEl) {
        countEl.textContent = active ? 'Showing ' + visible + ' of ' + state.rows.length : '';
        countEl.hidden = !active;
      }
      if (clearFiltersEl) clearFiltersEl.hidden = !active;
    }

    function clearFilters() {
      state.orderOnly = false;
      if (searchEl) searchEl.value = '';
      if (brandEl) brandEl.value = '';
      if (strengthEl) strengthEl.value = '';
      if (flavorEl) flavorEl.value = '';
      if (mgEl) mgEl.value = '';
      setStockView('in');
    }

    function setStockView(view) {
      state.stockView = view === 'all' ? 'all' : 'in';
      Array.prototype.forEach.call(stockBtns, function (b) {
        var on = b.getAttribute('data-nh-qo-stock') === state.stockView;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyFilters();
    }

    function toggleOrderView() {
      if (!state.orderOnly) {
        if (update().items === 0) return;
        if (searchEl) searchEl.value = '';
        if (brandEl) brandEl.value = '';
        if (strengthEl) strengthEl.value = '';
        if (flavorEl) flavorEl.value = '';
        if (mgEl) mgEl.value = '';
        state.orderOnly = true;
      } else {
        state.orderOnly = false;
      }
      applyFilters();
      update();
      if (state.orderOnly) {
        /* jump to the top of the page: heading, search and filters stay
           visible with the order's products right below — never a stranded
           view at the bottom of a suddenly-short page */
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }
    }

    /* ---------- import summary (textContent only — CSV text is untrusted) ---------- */

    function summaryLine(parent, cls, text) {
      var p = document.createElement('p');
      p.className = 'nh-qo-sum__line ' + cls;
      p.textContent = text;
      parent.appendChild(p);
      return p;
    }

    /* shared panel shell for the import summary and the cart-issues report */
    function startPanel(titleText) {
      summaryEl.textContent = '';
      summaryEl.hidden = false;
      var box = document.createElement('div');
      box.className = 'nh-qo-sum';
      var head = document.createElement('div');
      head.className = 'nh-qo-sum__head';
      var title = document.createElement('strong');
      title.textContent = titleText;
      head.appendChild(title);
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'nh-qo-sum__close';
      close.setAttribute('aria-label', 'Dismiss');
      close.textContent = '×';
      close.addEventListener('click', function () { summaryEl.hidden = true; });
      head.appendChild(close);
      box.appendChild(head);
      return box;
    }

    function renderSummary(plan) {
      if (!summaryEl) return;
      var okCount = 0;
      plan.set.forEach(function (s) { if (s.qty > 0) okCount++; });
      var box = startPanel('File imported — ' + okCount + ' of ' + plan.totalLines + ' lines filled in below');

      plan.adjusted.forEach(function (a) {
        summaryLine(box, 'is-note', a.title + ': you asked for ' + a.requested +
          ', set to ' + a.set + (a.capped
            ? ' (maximum ' + a.set + ' per product per order).'
            : ' (this product is ordered in fixed steps).'));
      });
      plan.soldout.forEach(function (t) {
        summaryLine(box, 'is-warn', t + ' is sold out right now — not added.');
      });
      plan.ambiguous.forEach(function (a) {
        summaryLine(box, 'is-warn', '“' + a.query + '” could be more than one product (' +
          a.options.join(' / ') + ') — please type more of the name.');
      });
      plan.unmatched.forEach(function (n) {
        summaryLine(box, 'is-bad', '“' + n + '” was not found — check the spelling or search for it below.');
      });
      if (!plan.adjusted.length && !plan.soldout.length && !plan.ambiguous.length && !plan.unmatched.length) {
        summaryLine(box, 'is-good', 'Everything matched. Check the quantities, then press “Add all to cart”.');
      }
      summaryEl.appendChild(box);
    }

    /* after a partly-failed add-to-cart: what landed, what needs attention */
    function renderCartIssues(addedCount, failures) {
      if (!summaryEl) return;
      var box = startPanel('Added ' + addedCount + (addedCount === 1 ? ' product' : ' products') +
        ' to your cart — ' + failures.length + (failures.length === 1 ? ' item needs' : ' items need') + ' attention');
      failures.forEach(function (f) {
        summaryLine(box, 'is-warn', f + '.');
      });
      summaryLine(box, 'is-note', 'The quantities below were kept for these items only — adjust them and press “Add all to cart” again, or just continue to the cart.');
      summaryEl.appendChild(box);
      if (summaryEl.scrollIntoView) summaryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function applyImportText(text) {
      var plan = NHQO.buildImportPlan(text, state.rows);
      var byVid = {};
      state.rows.forEach(function (r) { byVid[r.vid] = r; });
      plan.set.forEach(function (s) {
        var r = byVid[s.vid];
        if (!r) return;
        setRowQty(r, s.qty);
        if (s.qty > 0) {
          r.el.classList.remove('nh-qo-row--hit');
          void r.el.offsetWidth; /* restart the highlight animation */
          r.el.classList.add('nh-qo-row--hit');
        }
      });
      clearFilters();
      update();
      renderSummary(plan);
      if (summaryEl && summaryEl.scrollIntoView) summaryEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return plan;
    }
    rootEl.__nhqoImportText = applyImportText; /* used by the preview tests */

    /* ---------- example file ---------- */

    function downloadExample() {
      var blob = new Blob([NHQO.buildExampleCsv(state.rows)], { type: 'text/csv;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'nicohub-order-form.csv';
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
    }

    /* ---------- add to cart ---------- */

    function barMessage(text, isError) {
      if (!barMsgEl) return;
      barMsgEl.textContent = text || '';
      barMsgEl.hidden = !text;
      barMsgEl.classList.toggle('is-error', !!isError);
    }

    function busy(on) {
      if (addBtn) {
        addBtn.classList.toggle('is-busy', on);
        addBtn.disabled = on || update().items === 0;
      }
      /* progress lives in the count slot — the bar never grows a second line */
      if (on && barCountEl) { barCountEl.textContent = 'Adding to cart…'; state.lastCount = 'Adding to cart…'; }
    }

    /* remember that we just sent the order — only then does coming Back
       from the cart reset the page (returning from a product page must not) */
    function markAdded() {
      try { sessionStorage.setItem('nhqoAdded', '1'); } catch (e) { /* private mode */ }
    }
    function consumeAdded() {
      try {
        var v = sessionStorage.getItem('nhqoAdded') === '1';
        sessionStorage.removeItem('nhqoAdded');
        return v;
      } catch (e) { return false; }
    }

    function postItems(items) {
      return fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          return { ok: res.ok && !j.status, body: j };
        });
      });
    }

    /* Tell the theme's own cart UI (header badge + popup) that the cart
       changed — used when we stay on the page after a partial add. */
    function refreshThemeCart() {
      try {
        if (!window.Alpine || !window.Alpine.store || !Alpine.store('xCartHelper')) return;
        var secs = Alpine.store('xCartHelper').getSectionsToRender() || [];
        if (!secs.length) return;
        fetch(window.location.pathname + '?sections=' + secs.map(function (s) { return s.id; }).join(','))
          .then(function (r) { return r.json(); })
          .then(function (j) {
            secs.forEach(function (sec) {
              var el = document.querySelector(sec.selector);
              if (!el || !j[sec.id]) return;
              var doc = new DOMParser().parseFromString(j[sec.id], 'text/html');
              var fresh = doc.querySelector(sec.selector);
              if (fresh) el.innerHTML = fresh.innerHTML;
            });
            try {
              var bubble = document.querySelector('#cart-icon-bubble span');
              if (bubble) Alpine.store('xCartHelper').currentItemCount = parseInt(bubble.textContent, 10) || 0;
            } catch (e2) {}
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          })
          .catch(function () {});
      } catch (e) { /* theme machinery absent (preview/tests) — badge updates on next page */ }
    }

    /* If the one-shot add fails (usually not enough stock for one line),
       read the cart and add line by line so everything orderable still lands. */
    function fallbackSequential(items) {
      return fetch(cartJsUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var inCart = {};
          (cart.items || []).forEach(function (it) {
            inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity;
          });
          var byVidTitle = {};
          state.rows.forEach(function (r) { byVidTitle[parseInt(r.vid, 10)] = r.title; });
          var failures = [];
          var failedIds = [];
          var chain = Promise.resolve();
          items.forEach(function (item) {
            chain = chain.then(function () {
              var delta = item.quantity - (inCart[item.id] || 0);
              if (delta <= 0) return null; /* already in the cart */
              return postItems([{ id: item.id, quantity: delta }]).then(function (out) {
                if (!out.ok) {
                  var title = (byVidTitle[item.id] || ('item ' + item.id));
                  var why = out.body && (out.body.description || out.body.message);
                  if (why) why = String(why).replace(/[.\s]+$/, '');
                  failures.push(title + (why ? ' — ' + why : ''));
                  failedIds.push(item.id);
                }
              });
            });
          });
          return chain.then(function () { return { failures: failures, failedIds: failedIds }; });
        });
    }

    function addAll() {
      var items = [];
      state.rows.forEach(function (r) {
        var q = rowQty(r);
        if (q > 0 && r.available) items.push({ id: parseInt(r.vid, 10), quantity: q });
      });
      if (!items.length) return;
      barMessage('');
      busy(true);
      postItems(items).then(function (out) {
        if (out.ok) { markAdded(); window.location.href = cartUrl; return null; }
        return fallbackSequential(items).then(function (result) {
          if (!result.failures.length) { markAdded(); window.location.href = cartUrl; return; }
          /* keep quantities only on the items that need attention;
             everything that reached the cart gets cleared from the page */
          var failedSet = {};
          result.failedIds.forEach(function (id) { failedSet[id] = true; });
          var added = 0;
          state.rows.forEach(function (r) {
            if (rowQty(r) > 0 && !failedSet[parseInt(r.vid, 10)]) { setRowQty(r, 0); added++; }
          });
          busy(false);
          update();
          refreshThemeCart();
          renderCartIssues(added, result.failures);
          barMessage(added + ' added to your cart · ' + result.failures.length +
            ' could not be added — see the note above the product list.', true);
        });
      }).catch(function () {
        busy(false);
        update();
        barMessage('Could not reach the store — please check your connection and try again.', true);
      });
    }

    /* ---------- extra catalog pages (only if the store grows past 250) ---------- */

    function loadMorePages() {
      var more = rootEl.querySelector('[data-nh-qo-more]');
      if (!more || !listEl || typeof DOMParser === 'undefined') return;
      var pages = Math.min(parseInt(more.getAttribute('data-pages'), 10) || 1, 8);
      var chain = Promise.resolve();
      for (var n = 2; n <= pages; n++) {
        (function (pageNo) {
          chain = chain.then(function () {
            var url = window.location.pathname + '?page=' + pageNo;
            return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var rows = doc.querySelectorAll('.nh-qo-row');
              Array.prototype.forEach.call(rows, function (rowEl) {
                listEl.appendChild(document.importNode(rowEl, true));
              });
            }).catch(function () { /* page fetch failed — keep what we have */ });
          });
        })(n);
      }
      chain.then(function () {
        more.remove();
        collectRows();
        rebuildFilters();
        applyFilters();
        update();
        if (state.bss) applyBssPricing(state.bss.tags, state.bss.rulesData);
      });
    }

    /* ---------- wire up ---------- */

    function applyBssPricing(tags, rulesData) {
      var rule = NHQO.resolveBssRule(tags, rulesData);
      if (!rule) return false;
      state.bss = { tags: tags, rulesData: rulesData };
      state.bssLadder = rule.ladder || null;
      state.rows.forEach(function (r) {
        r.price = NHQO.bssPrice(rule, r.nameNorm, parseInt(r.el.dataset.price, 10) || 0);
      });
      update();
      return true;
    }
    rootEl.__nhqoApplyBss = applyBssPricing;

    collectRows();
    rebuildFilters();
    applyFilters();
    update();
    loadMorePages();

    (function () {
      var tagAttr = rootEl.getAttribute('data-customer-tags');
      if (tagAttr && typeof window !== 'undefined' && window.NH_BSS_RULES) {
        applyBssPricing(tagAttr.split('|||'), window.NH_BSS_RULES);
      }
    })();

    if (searchEl) searchEl.addEventListener('input', applyFilters);
    if (brandEl) brandEl.addEventListener('change', applyFilters);
    if (strengthEl) strengthEl.addEventListener('change', applyFilters);
    if (flavorEl) flavorEl.addEventListener('change', applyFilters);
    if (mgEl) mgEl.addEventListener('change', applyFilters);
    Array.prototype.forEach.call(stockBtns, function (b) {
      b.addEventListener('click', function () { setStockView(b.getAttribute('data-nh-qo-stock')); });
    });
    if (clearFiltersEl) clearFiltersEl.addEventListener('click', clearFilters);
    if (importBtn && fileEl) importBtn.addEventListener('click', function () { fileEl.value = ''; fileEl.click(); });
    if (fileEl) fileEl.addEventListener('change', function () {
      var f = fileEl.files && fileEl.files[0];
      if (!f) return;
      var reader = new FileReader();
      reader.onload = function () { applyImportText(String(reader.result || '')); };
      reader.readAsText(f);
    });
    if (exampleBtn) exampleBtn.addEventListener('click', downloadExample);
    if (viewBtn) viewBtn.addEventListener('click', toggleOrderView);
    if (addBtn) addBtn.addEventListener('click', addAll);
    if (clearBtn) clearBtn.addEventListener('click', function () {
      state.rows.forEach(function (r) { setRowQty(r, 0); });
      if (summaryEl) summaryEl.hidden = true;
      barMessage('');
      update();
    });

    /* Coming BACK from the cart right after sending an order restores this
       page exactly as it was — mid-"Adding to cart…", button locked,
       quantities still filled (a double-order trap). The order IS in the
       cart, so reset the page — but ONLY then. Coming back from a product
       page must keep the order untouched. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (!consumeAdded()) return;
      state.rows.forEach(function (r) { setRowQty(r, 0); });
      if (summaryEl) summaryEl.hidden = true;
      barMessage('');
      busy(false);
      update();
    });
  }

  NHQO.initAll = function () {
    var roots = document.querySelectorAll('[data-nh-qo-root]');
    Array.prototype.forEach.call(roots, initRoot);
  };

  root.NHQO = NHQO;

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', NHQO.initAll);
    } else {
      NHQO.initAll();
    }
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);
